import { View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { observer } from 'mobx-react-lite';
import { style } from './ModalPrivacyPolicy.style';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import BaseModal from '../../base-modal/BaseModal';
import PolicyPrivacyContent from '@photosi/rn-components/policy-privacy-content/PolicyPrivacyContent';

export const ModalPrivacyPolicy = observer(
  ({ dynamicModalVisible, type, dynamicModalLayer: { id } }: DynamicModalProps) => {
    const {
      i18n,
      dynamicModal: { closeModal },
    } = useStore();

    return (
      <BaseModal
        testID={TestIDs.PRIVACY_POLICY}
        modalWidth={631}
        modalIcon={null}
        title={i18n.t('modal-privacy-policy:editor-privacy-policy-info')}
        body={
          <View style={style.contentWrapper}>
            <PolicyPrivacyContent />
          </View>
        }
        onClose={closeModal}
        onCloseOutside={closeModal}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
